import {
  CommentCountClient,
  ClientOutput,
} from 'sagas/Clients/Comments/CommentCountClient';
import { CommentCountInput } from 'sagas/Clients/Comments/CommentCountClient/Models';
import {
  call,
  put,
  select,
  CallEffect,
  SelectEffect,
  PutEffect,
} from 'redux-saga/effects';
import { ApiGetter } from 'sagas/Clients/ApiGetter';
import { actions } from 'reducers/CommentHistory/Summary';
import {
  currentOrganizationUUIDSelector,
  dateRangeSelector,
} from 'selectors/CommentHistory/Controls';
import { DateRange } from 'models/CommentHistory';

export const commentCountClient = new CommentCountClient(new ApiGetter());

export function* getSummary(): Generator<
  CallEffect | SelectEffect | PutEffect,
  void,
  string | ClientOutput | DateRange
> {
  const organizationUUID = (yield select(
    currentOrganizationUUIDSelector
  )) as string;
  const dateRange = (yield select(dateRangeSelector)) as DateRange;

  const input: CommentCountInput = {
    organizationUUID,
    dateRange,
  };
  const { data, error } = (yield call(
    [commentCountClient, commentCountClient.retrieveAsync],
    input
  )) as ClientOutput;

  if (error || !data) {
    yield put(actions.setSummaryData(undefined));
    return;
  }

  yield put(actions.setSummaryData(data));
}
